export enum NOTIFY {
  NEW = 'NEW',
}

export enum ERRORS {
  DEFAULT_MUTATION_ERROR = 'Something went wrong! Please try again!',
}
